import Vue from 'vue';


import NoSsr from '@/components/utils/no-ssr';

import VueYoutube from 'vue-youtube';
import * as VueGoogleMaps from 'vue2-google-maps';
import Vue2TouchEvents from 'vue2-touch-events';
import Transitions from 'vue2-transitions';
import Helper from './plugins/Helper';


import App from './App.vue';


import { createRouter } from './router';
import { createStore } from './store/';
import './assets/styl/main.styl';

const format = require('string-format');

const mdpConfig = require('../mdp.config');

format.extend(String.prototype, {});

const domTemp = document.body.querySelector('#app-wrapper .content');
const articles = domTemp.querySelectorAll('.lc-product');
window.products = {};
for (let i = 0; i < articles.length; i += 1) {
  const id = articles[i].getAttribute('id');
  window.products[id] = {};
  window.products[id].linkElement = articles[i].querySelector('.product-link');
  window.products[id].priceElement = articles[i].querySelector('.price');
}

/**
 * Parses a value and returns the appropriate type (string, number, boolean, or undefined)
 * @param {string|undefined} value - The input value to parse
 * @return {string|number|boolean|undefined} The parsed value with appropriate type
 */
function parseValue(value) {
  // Return undefined if the value is undefined or null
  if (value === undefined || value === null) return undefined;
  // Trim the string if it's a string
  const trimmedValue = typeof value === 'string' ? value.trim() : String(value);
  // Check for boolean values
  if (trimmedValue.toLowerCase() === 'true') return true;
  if (trimmedValue.toLowerCase() === 'false') return false;

  if (/^-?\d+(\.\d+)?$/.test(trimmedValue)) { // only contains digits and possibly a dot and a minus sign
    return Number(trimmedValue);
  }

  return trimmedValue;
}

const attributes = {};
Object.keys(mdpConfig.attributes).forEach((attribute) => {
  window[`___${attribute}`] = domTemp.getAttribute(attribute);
  const attr = domTemp.getAttribute(attribute) !== `#${attribute}#` ? domTemp.getAttribute(attribute) : mdpConfig.attributes[attribute].value;
  attributes[attribute] = parseValue(attr);
});

const tokens = require('@/assets/tokens/tokens.json');

Vue.prototype.$tokens = Vue.$tokens = tokens; // eslint-disable-line
Vue.component('NoSsr', NoSsr);
Vue.use(VueYoutube);
Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyD7UU8Bua1Wr8dV3Wc0cc96d52be96XC4U' } });
Vue.use(Transitions);
Vue.use(Helper);

Vue.use(Vue2TouchEvents);

export function createApp(version = 'fr') { // eslint-disable-line
  const store = createStore(attributes);
  const router = createRouter(version, store);
  const app = new Vue({
    router,
    store,
    render: h => h(App),
  });


  return { app, router, store };
}

